import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer className="border-t border-line bg-night mt-16">
    <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm text-fg-muted">
        <p>© {new Date().getFullYear()} OwnDecks. Made for Dublin's music scene.</p>
        <div className="flex gap-6">
          <Link to="/terms" className="hover:text-acid">Terms</Link>
          <Link to="/privacy" className="hover:text-acid">Privacy</Link>
          <Link to="/trust" className="hover:text-acid">Trust & safety</Link>
        </div>
      </div>
    </div>
  </footer>
);
